import React, { useState } from 'react';
import getConfig from 'next/config';
import { Box } from '@mui/material';
import { Building } from '@procore/core-icons';
import { colors } from '@procore/core-react';
import Image from 'next/image';
import { useStyles } from './BusinessLogo.styles';

const { publicRuntimeConfig } = getConfig();

export type LogoSize = 'sm' | 'lg';

interface BusinessLogoProps {
  logoUrl: string;
  size: LogoSize;
}

const BusinessLogo = ({ logoUrl, size }: BusinessLogoProps) => {
  const classes = useStyles();
  const [logoSrc, setLogoSrc] = useState(logoUrl);
  const responsiveSizing = {
    xs: '80px',
    sm: '90px',
    md: '90px',
    lg: size === 'lg' ? '140px' : '100px',
  };

  const loadDefaultThumbnail = (img) => {
    if (img.target.naturalWidth === 0) {
      setLogoSrc(
        `${publicRuntimeConfig.assetsStaticBasePath}/business-profile/building.png`
      );
    }
  };

  return logoSrc ? (
    <Box
      sx={{
        height: responsiveSizing,
        width: responsiveSizing,
      }}
    >
      <Image
        className={classes.logo}
        src={logoSrc}
        alt="Company Logo"
        height={size === 'lg' ? 140 : 100}
        width={size === 'lg' ? 140 : 100}
        onError={loadDefaultThumbnail}
        priority
        loading="eager"
        unoptimized
      />
    </Box>
  ) : (
    <Box
      className={classes.defaultLogoContainer}
      sx={{
        height: responsiveSizing,
        width: responsiveSizing,
        minHeight: responsiveSizing,
        minWidth: responsiveSizing,
      }}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Building style={{ height: '50%', width: '50%' }} color={colors.gray60} />
    </Box>
  );
};

export default BusinessLogo;
